/**
 * companyUpdateOverride — short-lived shield around meta.companyUpdate
 * so a stale /meta refetch (60-second auto-poll, or KV's per-region
 * read cache returning yesterday's value) can't briefly revert the
 * Company Update Zoe just saved.
 *
 * Same pattern as execSummaryOverride / actionItemOverrides.
 *
 * 15s TTL is well above KV's typical propagation time but short enough
 * that genuine remote changes (another teammate's save) propagate
 * within a normal page interaction.
 */

const OVERRIDE_TTL_MS = 15_000

let override = null // { value, at } | null

export function rememberCompanyUpdate(value) {
  override = { value, at: Date.now() }
  setTimeout(() => {
    if (override && Date.now() - override.at >= OVERRIDE_TTL_MS) {
      override = null
    }
  }, OVERRIDE_TTL_MS + 100)
}

export function getCompanyUpdateOverride() {
  if (!override) return undefined
  if (
    !Number.isFinite(override.at) ||
    Date.now() - override.at >= OVERRIDE_TTL_MS
  ) {
    override = null
    return undefined
  }
  return override.value
}

export function clearCompanyUpdateOverride() {
  override = null
}
